import { render, staticRenderFns } from "./SalaryPaymentModal.vue?vue&type=template&id=b9916b06"
import script from "./SalaryPaymentModal.vue?vue&type=script&lang=js"
export * from "./SalaryPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports